module.exports = __webpack_public_path__ + "media/svg/vu-f04f6853.svg";